import toastr from "toastr";
import resources from "@/resources";


toastr.options = {
    "positionClass": "toast-bottom-center",
};

const toast =
{
    error(res,msg)
    {
        toastr.error(msg || resources(res), resources('status.errorShort'))
    },

    success(res, msg)
    {
        toastr.success(msg || resources(res), resources('status.successShort'))
    }
}

export default toast;
